import { defineStore } from 'pinia'
import http from '@/clients/Axios'
import { isEmail, isNumber } from '@/helpers'
import { useStorage } from '@vueuse/core'

export const useAuthStore = defineStore('authStore', {
  state: () => ({
    user: useStorage('user', {}),
  }),
  getters: {
    isAuthenticated() {
      return this.user ? true : false
    },
  },
  actions: {
    async login(login, password, token_device) {
      let loginForm = null

      if (isNumber(login)) {
        loginForm = {
          phone: login,
          password: password,
          token_device: token_device,
        }
      } else if (isEmail(login)) {
        loginForm = {
          email: login,
          password: password,
          token_device: token_device,
        }
      } else {
        loginForm = {
          username: login,
          password: password,
          token_device: token_device,
        }
      }

      await http.post('/user/login', loginForm).then((res) => {
        if (res.data.message === 'OK') {
          localStorage.setItem('aid', res.data.data)
          http.get('/user/index').then((res) => {
            if (res.data.message === 'OK') {
              this.user = res.data.data
            }
          })
        }
      })
    },
    logout() {
      localStorage.clear()
      this.user = null
    },
  },
})
